export const emailCampaignCopy = {
  editorTitle: 'Campanha de e-mail',
  editorDescription: 'Salve um rascunho para revisar antes do envio.',
  name: 'Nome da campanha',
  subject: 'Assunto do e-mail',
  content: 'Conteúdo do e-mail',
  searchLabel: 'Buscar contato por nome ou e-mail',
  search: 'Buscar',
  schedule: 'Agendamento (opcional)',
  rate: 'E-mails por minuto',
  contentPlaceholder: 'Escreva sua campanha...',
  saveDraft: 'Salvar rascunho',
  inbox: 'Caixa de e-mail para envio',
  selectInbox: 'Selecione uma caixa de e-mail',
  audience: 'Público da campanha',
  allContacts: 'Todos os contatos com e-mail',
  labeledContacts: 'Contatos com as etiquetas selecionadas',
  specificContacts: 'Selecionar contatos específicos',
  labels: 'Etiquetas (qualquer uma)',
  noLabels: 'Cadastre etiquetas nos contatos para usar este público.',
  clearSelection: 'Limpar seleção',
  searchHint: 'Busque para listar contatos com e-mail.',
  sendingHint:
    'Sem agendamento, o envio começa após sua confirmação. Contatos bloqueados, inscrições canceladas e e-mails repetidos serão excluídos do público.',
  reviewTitle: 'Revisão e resultado da campanha',
  previewTitle: 'Prévia do e-mail',
  refreshResult: 'Atualizar resultado',
  previous: 'Anterior',
  next: 'Próxima',
  close: 'Fechar',
  subjectPrefix: 'Assunto:',
  previewHint:
    'A prévia mostra as variáveis antes da personalização. Cada envio incluirá o link para cancelar a inscrição.',
  checkingAudience: 'Conferindo os destinatários...',
  confirmConsent:
    'Revisei o e-mail e confirmo o envio para este público. Tenho autorização para enviar esta campanha aos contatos selecionados.',
  deliveryHint:
    '“Enviado” significa que o servidor de e-mail aceitou o envio. Não confirma entrega ou leitura. Envios não confirmados não serão repetidos automaticamente.',
  contact: 'Contato',
  status: 'Situação',
  details: 'Detalhes',
  noDeliveries: 'Nenhum envio registrado.',
  refresh: 'Atualizar',
  newCampaign: 'Nova campanha',
  edit: 'Editar',
  pause: 'Pausar',
  resume: 'Retomar',
  title: 'Campanhas de e-mail',
  description:
    'Crie campanhas para os contatos da sua empresa e acompanhe os envios.',
  connectHint: 'Conecte uma caixa de e-mail da empresa para criar campanhas.',
  connect: 'Conectar caixa de e-mail',
  loading: 'Carregando campanhas...',
  empty: 'Nenhuma campanha de e-mail criada.',
  separator: ' · ',
  variables:
    'Use {{nome}} para o nome do contato e {{empresa}} para o nome da empresa. O link para cancelar a inscrição será incluído automaticamente.',
  selected: 'contato(s) selecionado(s).',
  rateUnit: 'e-mails por minuto',
  eligible: 'destinatário(s) apto(s) de',
  contacts: 'contato(s).',
  page: 'Página',
  sent: 'Enviados',
  pending: 'Na fila',
  failed: 'Falhas',
  uncertain: 'Não confirmados',
};
